import { SectionLabel } from "../SectionLabel";
import { RewardFeatureCard } from "./RewardFeatureCard";
import { RewardsPreviewCard } from "./RewardsPreviewCard";

const GiftIcon = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="8" width="18" height="4" rx="1" />
    <path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
    <path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5" />
  </svg>
);

const UsersIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2.5 20c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5" />
    <path d="M15 4.7a3.5 3.5 0 0 1 0 6.6M18 13.8c2.1.9 3.5 3 3.5 5.7" />
  </svg>
);

const rewardCards = [
  { icon: <GiftIcon />, title: "Reward Loyal Customers", description: "Turn first-time visitors into regulars" },
  { icon: <UsersIcon />, title: "Grow Your Community", description: "Connect with locals who support you" },
];

const transactions = [
  { title: "Coffee at Café Luna", time: "2 hours ago", points: "+50" },
  { title: "Haircut at Style Studio", time: "Yesterday", points: "+100" },
  { title: "Pizza at Tony's", time: "2 days ago", points: "+75" },
];

export const CommunityRewardsSection = () => {
  return (
    <section className="w-full px-[16px] sm:px-6 lg:px-[80px] pt-16 lg:pt-[160px] pb-16 lg:pb-[120px]">
      <div className="mx-auto w-full max-w-[1620px] rounded-[28px] lg:rounded-[36px] bg-[#D0D0D0] px-[20px] sm:px-10 lg:px-[50px] py-10 lg:pt-[70px] lg:pb-[70px] grid grid-cols-1 lg:grid-cols-[1fr_1.12fr] gap-10 lg:gap-14 items-center">
        <div>
          <SectionLabel align="left">Community Rewards</SectionLabel>

          <h2 className="mt-6 lg:mt-12 text-[#171717] font-normal leading-[1.2] tracking-[-1.5px] text-[32px] sm:text-[44px] lg:text-[64px]">
            A Built-In Community
            <br />
            <span className="text-[#D90000]">Rewards Program</span>
          </h2>

          <p className="mt-[16px] lg:mt-8 max-w-[580px] text-[#2A2A2A] text-[15px] lg:text-[20px] leading-[1.4]">
            Reward customers with Coupon Points. They earn points city-wide and spend them directly on your offers,
            creating a powerful local loyalty loop.
          </p>

          <div className="mt-8 lg:mt-[70px] space-y-4 lg:space-y-6 max-w-[486px]">
            {rewardCards.map((card) => (
              <RewardFeatureCard key={card.title} {...card} />
            ))}
          </div>
        </div>

        <RewardsPreviewCard transactions={transactions} />
      </div>
    </section>
  );
};
